import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-pratiche-payment',
  templateUrl: './pratiche-payment.component.html',
  styleUrls: ['./pratiche-payment.component.css']
})
export class PratichePaymentComponent implements OnInit {
	@Input() public row: any = 0;
	@Input() writePermission: boolean = false;
	pagamenti: any[] = [];
	praticheSync: Subscription;

	modalInput: any = {
		size: '',
		title: '',
		subtitle: '',
		data: {
			id: 0,
			crc: 0,
			person: null,
			uid: null,
			id_prat: null,
			reset: false,
		}
	};

	public formatter : any;

	constructor(private dataService: DataService) {
		this.formatter = this.dataService.getCommon().getLocale();
	}

	ngOnInit() {
		this.praticheSync = this.dataService.pratiche$.subscribe(
			() => {
				this.getPagamenti();
			}
		);
	}

	ngOnChanges(changes: any){
		console.log('CHANGE PRATICHE-PAYMENT', this.row);
		if(changes.row) {
			console.log('CHANGE PRATICHE-PAYMENT', this.row);
			//this.row = row;
			this.getPagamenti();
		}
    }

	getPagamenti() {
		console.log("getPagamenti row:", this.row);
		this.dataService.getPagamentiByUid(this.row.uid, (pagamenti) => {
			this.pagamenti = pagamenti;
		});
	}

	nuovoPagamento() {
		console.log('nuovoPagamento', this.row);

		this.modalInput = {
			size: 'large-modal',
			title: 'Immissione Manuale Pagamenti',
			subtitle: 'Pratica: ' + this.row.id_prat,
			data: this.row
		};
	}

	getInnerEvents(event: any) {
		let localComuneId = true;
		let localFilters: any = [];
		let localSets: any = {};
		console.log('PRATICHE PAYMENTS INNER EVENT',event);
		if(event.aggiungiPagamento){
			localFilters.push({ "uid": event.uid });
			localSets = event.setValue;
			this.dataService.insertPagamento(event.uid, event.setValue,true,(err,data) => {
				if (err) {
					console.log('insertPagamento|error',err);
				}else {
					console.log('insertPagamento|success', data, localFilters)
				}
			});
		}
	}

	exportData() {
		console.log('export data');
		let filename = 'pagamenti';
		let data = [];
		for (let pagamento of this.pagamenti) {
			let item = {};
			item['Data Pagamento'] = this.formatter.toLocaleDate(pagamento.dataPagamento);
			item['Data Accredito'] = this.formatter.toLocaleDate(pagamento.dataAccredito);
			item['Somma Pagata'] = this.dataService.getCommon().getLocale().toCurrency(pagamento.sommaPagata);
			item['Riferimento'] = pagamento.rifBoll ? pagamento.rifBoll : "";
			item['Rata'] = (pagamento.rifRata && pagamento.rifRata != 0)?pagamento.rifRata:"No";
			item['Canale'] = pagamento.canale ? pagamento.canale : "";
			data.push(item)
		}
		this.dataService.exportCsv(filename,data);
	}

	ngOnDestroy() {
		this.praticheSync.unsubscribe();
	}
}
